import { Context } from './context.model';
import { AccountsResult } from './accounts-result.model';

export class PreferencesRequest {
    contextData: Context;
    accountList: AccountsResult[];
}